import { IClientSettings } from '@common/clientSettings';
import { IUser } from '@common/interfaces/user';
import { ASSETS_SETTINGS_LOCALSTORAGE_KEY } from '@ep-om/app.service';

// Default di istanza del motore v2: deciso dal backend via settings.json (sezione realtime.v2Enabled),
// persistito in localStorage sotto __ASSETS_SETTINGS. Lettura sincrona qui per non cambiare la firma
// di shouldUseRealtimeV2 (funzione pura usata in molti punti). Assente/illeggibile -> v2 spento.
export function isRealtimeV2EnabledForInstance(): boolean {
  try {
    const raw = localStorage.getItem(ASSETS_SETTINGS_LOCALSTORAGE_KEY);
    if (!raw) {
      return false;
    }
    const settings = JSON.parse(raw) as IClientSettings;
    return settings?.realtime?.v2Enabled === true;
  } catch {
    return false;
  }
}

export function shouldUseRealtimeV2(user?: Pick<IUser, 'settings'> | null): boolean {
  return user?.settings?.realtimeV2Enabled !== false && (isRealtimeV2EnabledForInstance() || user?.settings?.realtimeV2Enabled === true);
}
